exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_wks-ext.js
// module id = 256
// module chunks = 0 1 2 3 4